import { render, staticRenderFns } from "./PaymentBlocks.vue?vue&type=template&id=2913605a&lang=pug&"
import script from "./PaymentBlocks.vue?vue&type=script&lang=js&"
export * from "./PaymentBlocks.vue?vue&type=script&lang=js&"
import style0 from "./PaymentBlocks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports